import React, { useState, useRef, useEffect } from "react";
import { Container, Form, Row, Col, Button } from "react-bootstrap";
import AlertOverlay from "../../../components/Alert";
import { useNavigate } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";
import { useCargoSearchList } from "../../../apis/cargoSearchList/CargoSearchListProvider";
import { getPageName, getUiInterface, getSuccessMessage, getErrorMessage, getWordConnector } from "../../../locales/translationUtils";
import { useTranslation } from 'react-i18next';
import NavBar, { NavBarItem } from "../../../components/NavBar";
import CargoSearchList from "../../../types/cargoSearchList";

const CargoSearchListCreateView: React.FC = () => {
    const { t } = useTranslation();
    const [alert, setAlert] = useState<{
        message: string;
        variant: "success" | "danger" | "warning" | "info";
    } | null>(null);
    const { postCargoSearchList } = useCargoSearchList();
    const navigate = useNavigate();
    const descriptionRef = useRef<HTMLInputElement | null>(null);

    const [cargoSearchList, setCargoSearchList] = useState<CargoSearchList>({
        id: 0,
        version: 0,
        description: "",
        key: "",
        tipoInput: "",
    });

    const navItems: NavBarItem[] = [
        { label: t('cargoSearchList.labels.home'), route: "/", iconName: "house-door" },
        { label: t('cargoSearchList.labels.list'), route: "/CargoSearchList", iconName: "table" },
    ];

    const types = ["", "Text", "Number", "DateTime"];

    const handleChange = (e: React.ChangeEvent<any>) => {
        const { name, value } = e.target;
        setCargoSearchList((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const nullRequiredFields: string[] = [];

        if (!cargoSearchList.description) nullRequiredFields.push("Description");
        if (!cargoSearchList.key) nullRequiredFields.push("Key");

        if (nullRequiredFields.length > 0) {
            const warnMessage: string =
                nullRequiredFields.length === 1
                    ? getUiInterface("fieldRequiredSingle", {
                        field: nullRequiredFields[0],
                    })
                    : getUiInterface("fieldRequiredMultiple", {
                        fields: `${nullRequiredFields.slice(0, -1).join(", ")}${nullRequiredFields.length > 1
                            ? ` ${getWordConnector("and")} `
                            : ""
                            }${nullRequiredFields.slice(-1)}`,
                    });

            setAlert({ message: warnMessage, variant: "danger" });
            descriptionRef?.current?.focus();
            return;
        }

        try {
            const response = await postCargoSearchList(cargoSearchList);

            if (response?.messages == null && response?.data?.id) {
                const successMessage = getSuccessMessage("createCargoSearchList", { id: response.data.id });
                navigate(`/CargoSearchList`, {
                    state: {
                        message: successMessage,
                        variant: "success",
                    },
                });
            } else {
                setAlert({
                    message: getErrorMessage("genericError", { error: response?.messages }),
                    variant: "danger",
                });
            }
        } catch (error) {
            setAlert({
                message: getErrorMessage("genericError", {}),
                variant: "danger",
            });
        }
    };

    useEffect(() => {
        if (descriptionRef.current) {
            descriptionRef.current.focus();
        }
    }, []);

    return (
        <Container fluid>
            <NavBar items={navItems} />
            {alert && (
                <AlertOverlay
                    message={alert.message}
                    variant={alert.variant}
                    onClose={() => setAlert(null)}
                />
            )}

            <div className="mb-3"></div>
            <h2>{getPageName("createCargoSearchList")}</h2>
            <Form onSubmit={handleSubmit}>

                <Row>
                    <Col md={12} className="mb-3">
                        <Form.Group controlId="description">
                            <Form.Label>{t('cargoSearchList.fields.description')}</Form.Label>
                            <Form.Control
                                ref={descriptionRef}
                                type="text"
                                name="description"
                                value={cargoSearchList.description}
                                onChange={handleChange}
                                style={{ width: "20%" }}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={12} className="mb-3">
                        <Form.Group controlId="key">
                            <Form.Label>{t('cargoSearchList.fields.key')}</Form.Label>
                            <Form.Control
                                type="text"
                                name="key"
                                value={cargoSearchList.key}
                                onChange={handleChange}
                                style={{ width: "20%" }}
                            />
                        </Form.Group>
                    </Col>

                    {/* <Col md={12} className="mb-3">
                        <Form.Group controlId="type">
                            <Form.Label>Type</Form.Label>
                            <div style={{ position: "relative", width: "20%" }}>
                                <Form.Control
                                    as="select"
                                    name="tipoInput"
                                    value={cargoSearchList.tipoInput}
                                    onChange={handleChange}
                                    style={{
                                        appearance: "none",
                                        paddingRight: "30px"
                                    }}
                                >
                                    {types.map((t, index) => (
                                        <option key={index} value={t}>
                                            {t || "Selecione um tipo"}
                                        </option>
                                    ))}
                                </Form.Control>
                                <FaChevronDown
                                    style={{
                                        position: "absolute",
                                        right: "10px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        pointerEvents: "none",
                                    }}
                                />
                            </div>
                        </Form.Group>
                    </Col> */}
                </Row>
                <div className="mt-3 mb-3 d-flex gap-2">
                    <Button variant="primary" onClick={handleSubmit}>
                        {getUiInterface("create")}
                    </Button>
                </div>                    
            </Form>
        </Container>
    );
};

export default CargoSearchListCreateView;